
import { DropDownItem } from "@/models/Base/GlobalData";
import { MapRunawayPuzzleData } from "@/models/MapPois/Quest/Puzzle";
import {
  QuestMapPoi,
  Quest_CG_MinigameSection,
} from "@/models/MapPois/Quest/QuestMapPoi";
import { min, toArray } from "lodash";
import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import { Validations } from "vuelidate-property-decorators";
import {
  required,
  minLength,
  maxLength,
  integer,
} from "vuelidate/lib/validators";

@Component({
  components: {},
})
class MapRunaway extends Vue {
  @Prop({ default: null }) readonly getContentData!: Quest_CG_MinigameSection;
  @Prop({ default: true }) readonly difficultyLevel!: string;
  @Prop({ default: true }) readonly isEditingLocked!: boolean;

  runawayTimer = 0;
  updArray: any[] = [];

  get getUpdArray(): any[] {
    return this.updArray;
  }

  get getQuestPoiDropDown(): DropDownItem[] {
    if (this.getUpdArray.length > 0) {
      return this.$store.state.mapPoiStore.questMapPoi
        .filter((x: QuestMapPoi) => x.title.en !== "START_ZONE")
        .map((x: QuestMapPoi) => ({
          text: x.title.en,
          value: x.key,
          disabled:
            this.getUpdArray.filter((y: any) => y.id == x.key).length > 0
              ? true
              : false,
        }));
    } else {
      return this.$store.state.mapPoiStore.questMapPoi
        .filter((x: QuestMapPoi) => x.title.en !== "START_ZONE")
        .map((x: QuestMapPoi) => ({
          text: x.title.en,
          value: x.key,
          disabled: false,
        }));
    }
  }

  created(): void {
    this.getMapRunawayPuzzleData();
  }

  getMapRunawayDifficulty(): MapRunawayPuzzleData {
    if (this.difficultyLevel === "easy") {
      if (this.getContentData?.puzzle.puzzleData.easy === undefined) {
        this.getContentData!.puzzle.puzzleData.easy = this.setMapRunawayData();
        this.getContentData!.puzzle.puzzleData.easy.onFail = this.getContentData.puzzle.puzzleData.easy.onFail;
        this.getContentData!.puzzle.puzzleData.easy.onSuccess = this.getContentData.puzzle.puzzleData.easy.onSuccess;
        this.getContentData!.puzzle.puzzleData.easy.onIncorrect = this.getContentData.puzzle.puzzleData.easy.onIncorrect;
      }
      return this.getContentData?.puzzle.puzzleData
        .easy as MapRunawayPuzzleData;
    } else if (this.difficultyLevel === "hard") {
      if (this.getContentData?.puzzle.puzzleData.hard === undefined) {
        this.getContentData!.puzzle.puzzleData.hard = this.setMapRunawayData();
        this.getContentData!.puzzle.puzzleData.hard.onFail = this.getContentData.puzzle.puzzleData.hard.onFail;
        this.getContentData!.puzzle.puzzleData.hard.onSuccess = this.getContentData.puzzle.puzzleData.hard.onSuccess;
        this.getContentData!.puzzle.puzzleData.hard.onIncorrect = this.getContentData.puzzle.puzzleData.hard.onIncorrect;
      }
      return this.getContentData?.puzzle.puzzleData
        .hard as MapRunawayPuzzleData;
    } else {
      if (this.getContentData?.puzzle.puzzleData.default === undefined) {
        this.getContentData!.puzzle.puzzleData.default = this.setMapRunawayData();
      }
      return this.getContentData!.puzzle.puzzleData
        .default as MapRunawayPuzzleData;
    }
  }

  getMapRunawayPuzzleData(): void {
    var data = this.getMapRunawayDifficulty();
    this.updArray = toArray(data.targets);
    this.runawayTimer = data.timeout_Adjust_s;
  }
  setMapRunawayPuzzleData(): void {
    try {
      var data = this.getMapRunawayDifficulty();
      var targets = {} as any;
      this.getUpdArray.forEach((x: any) => {
        targets[x.id] = {
          id: x.id,
          value: false,
        };
      });
      data.targets = targets;
      data.timeout_Adjust_s = this.runawayTimer;
      this.$emit("updateData", this.getContentData.puzzle.puzzleData);
    } catch (error) {
      console.log(error);
    }
  }
  setMapRunawayData(): MapRunawayPuzzleData {
    return {
      targets: {},
      timeout_Adjust_s: 0,
      onFail: {
        txt: { en: "Failed!" },
        actions: {
          timerAction: { value: 5, parentID: "", status: "" },
        },
      },
      onSuccess: {
        txt: { en: "Success!" },
      },
      onIncorrect: {
        txt: { en: "Oops!" },
        actions: {
          timerAction: { value: 1, parentID: "", status: "" },
        },
      },
    };
  }

  AddNewItem(): void {
    if (!this.isEditingLocked) {
      this.getUpdArray.push({
        id: this.getQuestPoiDropDown.filter(
          (x: DropDownItem) => x.disabled == false
        )[0].value,
        value: "false",
      });
    }
    this.setMapRunawayPuzzleData();
  }
  removeItem(key: number): void {
    if (!this.isEditingLocked) {
      this.getUpdArray.splice(key, 1);
      this.setMapRunawayPuzzleData();
    }
  }

  @Watch("getContentData")
  getContentDataWatch(): void {
    this.getMapRunawayPuzzleData();
  }

  @Watch("difficultyLevel")
  getdifficultyLevelWatch(): void {
    this.getMapRunawayPuzzleData();
  }

  @Validations()
  validations = {
    runawayTimer: {
      required,
      integer,
    },
  };
}
export default MapRunaway;
